/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2023 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\utils\utils.js                                                   *
 * Project: Telemedicine-MyMedicine                                            *
 * Created Date: Monday, April 3rd 2023, 11:20:44 am                           *
 * Author: Shyam Mohan <shyam@codestax.ai>                                     *
 * -----                                                                       *
 * Last Modified:                                                              *
 * Modified By:                                                                *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

const log = console.log.bind(console);
import VueCookies from "vue-cookies";

const e = function(selector) {
  let element = document.querySelector(selector);
  if (element === null) {
    let s = `Element not found, selector ${selector} is wrong or js is not in the body`;
    log(s);
    return null;
  } else {
    return element;
  }
}

const handleError = function(err, router, errorName, loginPageName = '', tokenName = '') {
  console.log(errorName, err);

  if (err.response.status === 401) {
    window.alert('Authentication failure');
    if (tokenName === 'token' || tokenName === 'customerToken' || tokenName === 'doctorToken') {
      VueCookies.remove(tokenName);
    }

    if (loginPageName) {
      router.push({
        name: loginPageName,
      });
    }
  } else if (err.response.status === 500) {
    window.alert("Internal server error, Please try again later");
  } else if (err.response.status === 404 || err.response.status === 400){
    window.alert(err.response.data.message);
  } else {
    window.alert("Something went wrong....");
  }
}

export {
  log,
  e,
  handleError
};
